module.exports = __webpack_public_path__ + "static/img/4.cb67441f.jpg";